import React from "react";

import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { ClientAvatar } from "../avatars";


export interface ClientChipProps {
  clientId: string;
  name: string;
  showAvatar?: boolean;
  sx?: SxProps<Theme>;
}

const ClientChip: React.FC<ClientChipProps> = ({
  clientId,
  name,
  showAvatar = true,
  sx,
}) => {
  return (
    <Box
      key={clientId}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        ...sx,
      }}
    >
      {showAvatar && <ClientAvatar text={name} />}
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.9rem",
          fontWeight: 600,
          lineHeight: 1.2,
          minWidth: 0,
        }}
        noWrap
      >
        {name}
      </Typography>
    </Box>
  );
};

export default ClientChip;
